import { Typography as TypographyType } from '@/schemas/sceneDataSchema';
import { Typography } from '@mui/material';
import { useStoreFields } from '@/hooks/use-store-fields';

export const TypographyBlock = ({ component }: { component: TypographyType }) => {
  const displayText = useStoreFields(component.text, component.store_fields);

  return (
    <Typography
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {displayText}
    </Typography>
  );
};

export const TypographyInline = ({ component }: { component: TypographyType }) => {
  return (
    <Typography
      component={'span'}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {component.text}
    </Typography>
  );
};
